import { render, staticRenderFns } from "./ReviewFormDetail.vue?vue&type=template&id=039af5ce&scoped=true&"
import script from "./ReviewFormDetail.vue?vue&type=script&lang=ts&"
export * from "./ReviewFormDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewFormDetail.vue?vue&type=style&index=0&id=039af5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039af5ce",
  null
  
)

export default component.exports